import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Seances from './pages/Seances';
import Exercises from './pages/Exercises';
import Chat from './pages/Chat';
import User from './pages/User';
import Main from './pages/Main';
import Login from './pages/Login';
import Register from './pages/Register';

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/home' element={<Home />} />
          <Route path='/' element={<Main />} />
          <Route path='/shop' element={<Shop />} />
          <Route path='/seances' element={<Seances />} />
          <Route path='/exercises' element={<Exercises />} />
          <Route path='/chat' element={<Chat />} />
          <Route path='/user' element={<User />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;